import { render, staticRenderFns } from "./GameMenu.vue?vue&type=template&id=b7b087a6&scoped=true&"
import script from "./GameMenu.vue?vue&type=script&lang=js&"
export * from "./GameMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameMenu.vue?vue&type=style&index=0&id=b7b087a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b087a6",
  null
  
)

export default component.exports